import _ceil from 'lodash/ceil'
import _round from 'lodash/round'

export const watchGeolocation = ({ onSuccess, onFailure }) => {
  console.log('Getting geolocation')

  if (!('geolocation' in navigator)) {
    return onFailure('Geolocation is not available')
  }

  const options = {
    enableHighAccuracy: true,
    maximumAge: 10000,
    timeout: 1000
  }

  return navigator.geolocation.watchPosition(onSuccess, onFailure, options)
}

export const roundAccuracy = accuracy => {
  if (accuracy > 1000) return '>1km'
  if (accuracy > 20) return `±${_ceil(accuracy, -1)}m`
  if (accuracy <= 20) return `±${_round(accuracy)}m`
  return `±${accuracy}m`
}

export const splitBounds = boundsString => {
  const arr = boundsString.split(',')
  if (arr.length < 4) { return console.error('Geo Bounds formatted incorrectly: ', boundsString) }
  const sw = [arr[0], arr[1]]
  const ne = [arr[2], arr[3]]
  return [sw, ne]
}



// WEBPACK FOOTER //
// ./src/utils/geolocation.js